import React from "react";
import Hero from "../components/Hero";
import USPStrip from "../components/USPStrip";
import TrustBadges from "../components/TrustBadges";
import SavingsCalculator from "../components/SavingsCalculator";
import SalderingsSection from "../components/SalderingsSection";
import ProductShowcase from "../components/ProductShowcase";
import AegHighlight from "../components/AegHighlight";
import LogoMarquee from "../components/LogoMarquee";
import ProjectShowcase from "../components/ProjectShowcase";
import GoogleReviews from "../components/GoogleReviews";
import FAQSection from "../components/FAQSection";
import { motion } from "framer-motion";
import { Battery, Sun as SunIcon, Cpu, Wrench, BarChart3, Building2 } from "lucide-react";
import { Link } from "react-router-dom";

const ServicesGrid = () => {
  const services = [
    { icon: Battery, title: "Thuisbatterijen", desc: "Premium accusystemen van 5–30 kWh." },
    { icon: SunIcon, title: "Zonnepanelen", desc: "Hoogrendement panelen + uitbreidingen." },
    { icon: Cpu, title: "Slim energiebeheer", desc: "AI-gestuurde optimalisatie & monitoring." },
    { icon: Wrench, title: "Installatie service", desc: "Gecertificeerde monteurs door heel NL." },
    { icon: BarChart3, title: "Energie advies", desc: "Persoonlijk besparingsplan op maat." },
    { icon: Building2, title: "Zakelijk", desc: "Batterijoplossingen voor MKB & vastgoed." },
  ];
  return (
    <section className="section-pad" data-testid="services-grid">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand mb-3">Onze diensten</p>
          <h2 className="font-heading text-4xl md:text-5xl font-black tracking-tighter text-navy-900 text-balance">Eén partner voor je hele energieproject</h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className="group bg-white border border-slate-200 rounded-3xl p-7 hover:border-brand/40 hover:-translate-y-1 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-brand-soft flex items-center justify-center mb-5 group-hover:bg-brand group-hover:text-white text-brand transition-colors">
                <s.icon size={22} />
              </div>
              <h3 className="font-heading font-bold text-xl text-navy-900 mb-2">{s.title}</h3>
              <p className="text-slate-600 text-sm leading-relaxed">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

const CtaBand = () => (
  <section className="py-20 relative overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">
      <div className="relative rounded-[2.5rem] overflow-hidden bg-navy-900 p-10 lg:p-16">
        <div className="blob-pink absolute -top-20 -left-20 opacity-60" />
        <div className="blob-pink absolute -bottom-20 -right-20 opacity-40" />
        <div className="relative grid lg:grid-cols-2 gap-10 items-center">
          <div>
            <h3 className="font-heading text-3xl md:text-5xl font-black tracking-tight text-white text-balance">Klaar om de toekomst van energie in huis te halen?</h3>
            <p className="text-slate-300 mt-5 text-lg max-w-lg">Vraag een gratis adviesgesprek aan. Geen verplichtingen, wel duidelijkheid binnen 24 uur.</p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 lg:justify-end">
            <Link to="/contact" className="btn-pink" data-testid="cta-band-primary">Gratis advies aanvragen</Link>
            <a href="#calculator" className="btn-ghost !bg-white/10 !text-white !border-white/20 hover:!bg-white/20" data-testid="cta-band-secondary">Bereken besparing</a>
          </div>
        </div>
      </div>
    </div>
  </section>
);

const Home = () => (
  <main data-testid="home-page">
    <Hero />
    <USPStrip />
    <TrustBadges />
    <LogoMarquee />
    <SavingsCalculator />
    <SalderingsSection />
    <ProductShowcase />
    <AegHighlight />
    <ServicesGrid />
    <ProjectShowcase />
    <GoogleReviews />
    <FAQSection />
    <CtaBand />
  </main>
);

export default Home;
